import { render, staticRenderFns } from "./main-btn.vue?vue&type=template&id=4c9418b0&scoped=true&"
import script from "./main-btn.vue?vue&type=script&lang=js&"
export * from "./main-btn.vue?vue&type=script&lang=js&"
import style0 from "./main-btn.vue?vue&type=style&index=0&id=4c9418b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9418b0",
  null
  
)

export default component.exports